module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edmund Wilson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Edmund Wilson")]), _vm._v(" (1895-1972) was a novelist, memoirist, playwright, journalist, poet, and editor but it is as a literary critic that he is most highly regarded. His more than twenty books include "), _c('I', [_vm._v("Axel’s Castle")]), _vm._v(", "), _c('I', [_vm._v("Patriotic Gor")]), _vm._v("e, "), _c('I', [_vm._v("To the Finland Station")]), _vm._v(", and "), _c('I', [_vm._v("Memoirs of Hecate County.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/D63fXR/tc-custom/9781466899636.jpg?1722313789775",
      "alt": "This image is the cover for the book Patriotic Gore"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Patriotic Gore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Featuring critical and biographical portraits of notable figures of the American Civil War, "), _c('i', [_vm._v("Patriotic Gore")]), _vm._v(" remains one of Edmund Wilson's greatest achievements. Considered one of the 100 Best Nonfiction books by The Modern Library.")]), _c('br'), _c('br'), _vm._v("Figures discussed include Harriet Beecher Stowe, Abraham Lincoln, Ulysses S. Grant, William Tecumseh Sherman, and Oliver Wendell Holmes, among many others.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus & Giroux\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0